export default __webpack_public_path__ + "static/media/einvoice_api_registration_through_gsp.9dac787d.png";